module.exports = __webpack_public_path__ + "assets/Youtube.ac2eca69.svg";